import TabsWithList from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups_projects/components/tabs_with_list.vue?vue3';
import { RECENT_SEARCHES_STORAGE_KEY_GROUPS } from '~/filtered_search/recent_searches_storage_keys';
import { TIMESTAMP_TYPE_CREATED_AT, TIMESTAMP_TYPE_UPDATED_AT } from '~/vue_shared/components/resource_lists/constants';
import { GROUPS_SHOW_TABS, SORT_OPTION_UPDATED, SORT_OPTION_CREATED, FILTERED_SEARCH_TERM_KEY, FILTERED_SEARCH_NAMESPACE, SHARED_PROJECTS_TAB, SHARED_GROUPS_TAB } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/constants.js?vue3';
export default {
    GROUPS_SHOW_TABS,
    FILTERED_SEARCH_TERM_KEY,
    FILTERED_SEARCH_NAMESPACE,
    RECENT_SEARCHES_STORAGE_KEY_GROUPS,
    timestampTypeMap: {
        [SORT_OPTION_CREATED.value]: TIMESTAMP_TYPE_CREATED_AT,
        [SORT_OPTION_UPDATED.value]: TIMESTAMP_TYPE_UPDATED_AT
    },
    name: 'GroupsShowApp',
    components: {
        TabsWithList
    },
    props: {
        initialSort: {
            type: String,
            required: true
        },
        fullPath: {
            type: String,
            required: true
        }
    },
    computed: {
        tabs () {
            const tabsWithFullPathVariable = [
                SHARED_PROJECTS_TAB.value,
                SHARED_GROUPS_TAB.value
            ];
            return GROUPS_SHOW_TABS.map((tab)=>{
                if (tabsWithFullPathVariable.includes(tab.value)) {
                    return {
                        ...tab,
                        variables: {
                            fullPath: this.fullPath
                        }
                    };
                }
                return tab;
            });
        }
    }
};
